<template>
	<div>
		<Header :sel='1' @changePhone="changePhone"></Header>
		<div :class="['cd-main-content', showPhone ? 'nav-is-visible' : '']">
			<!-- your content here -->
			<!--banner-->
			<div class="banner_index" data-aos="fade-down">
				<div id="slideBox" class="slideBox">
					<div class="hd">
						<ul>
							<li v-for="(item, index) in bannerList" :key="index">{{ index + 1 }}</li>
						</ul>
					</div>
					<div class="bd">
						<ul>
							<li v-for="(item, index) in bannerList" :key="index" @click="goHref(item)"
								:style="{ backgroundImage: 'url(' + item.image + ')' }">
								<div class="banner_txt"><a href="javascript:void(0)">{{ item.title }}</a></div>
							</li>
						</ul>
					</div>
					<a class="prev" href="javascript:void(0)"></a> <a class="next" href="javascript:void(0)"></a>
				</div>
			</div>
			<!--banner-->
			<!--search-->
			<div class="search_bg">
				<div class="search">
					<input name="" type="text" placeholder="快速检索" class="search_txt" v-model="keyword" @keyup.enter="goMore('searchList?keyword='+keyword)" />
					<input name="" type="button" class="search_but" @click="goMore('searchList?keyword='+keyword)" />
				</div>
				<p>高频搜索内容：<a href="javascript:void(0)" @click="goMore('searchList?keyword='+item.name)"
						v-for="item in keyList" :key="item.id">{{item.name}}</a></p>
			</div>
			<!--search-->
			<!--模块-->
			<div class="main1">
				<div class="title1">
					<p><strong>模块成熟丰富，高度产品化，开箱即用</strong></p>
					<p>70+成熟的功能模块可满足工会日常所有工作</p>
					<p><a href="javascript:void(0)" @click="goMore('/solutionList')">查看更多智慧工会解决方案>></a></p>
				</div>
				<div class="main_c">
					<div id="slideBox2" class="slideBox2">
						<div class="bd">
							<ul>
								<li v-for="item in jiejuefanganList">
									<div class="pro_index_list">
										<div class="pro_index_list_li" data-aos="flip-left" v-for="items in item">
											<!-- <a href="javascript:void(0)" @click="goMore('/solutionDetail?id='+items.categoryCode)"> -->
												<a href="javascript:void(0)" @click="goMore('/solutionList')">
												<img
													:src="items.image?items.image:item.image" />
												<div class="pro_index_white">{{ items.categoryName }}</div>
											</a></div>

									</div>
								</li>

							</ul>
						</div>
						<a class="prev" href="javascript:void(0)"></a> <a class="next" href="javascript:void(0)"></a>
					</div>
				</div>
			</div>
			<!--模块-->
			<!--案例介绍-->
			<div class="main3_bg">
				<div class="main1"  data-aos="fade-down">
					<div class="title1">
						<p><strong>案例介绍</strong></p>
						<p>★真实案例　★实际场景　★成熟模块　★拿来就用　★简单省心</p>
						<p><a href="javascript:void(0)" @click="goMore('/caseList')">查看更多智慧工会案例>></a></p>
					</div>
					<div class="main_c">
						<ul class="case_list">
							<li  v-for="item in caseList"><a href="javascript:void(0)" @click="goMore('/caseDetail?id='+item.id)">
									<div class="case_l">{{ item.clientName }}</div>
									<div class="case_r">{{ item.caseName }}</div>
								</a></li>
						</ul>
					</div>
				</div>
			</div>
			<!--案例介绍-->
			<!--关于我们-->
			<div class="main1" data-aos="fade-down">
				<div class="title1">
					<p><strong>选择数码人，就是选择舒心</strong></p>
					<p>10余年专注高校工会业务，用真诚的“好客山东”精神热情对待每个客户</p>
				</div>
				<div class="main_c">
					<div class="pc_img youshi_bg">

						<ul class="shuxin_list">
							<li class="youshi1">
								<p><strong>创新不辍</strong></p>
								<p>60+软件著作权诠释数码人勇立潮头的不竭创新动力</p>
							</li>
							<li class="youshi2">
								<p><strong>专注、专业，更擅长</strong></p>
								<p>10+年专注智慧工会，具备丰富的智慧工会解决方案</p>
							</li>
							<li class="youshi3">
								<p><strong>服务有保障</strong></p>
								<p>100+高校工会的选择，口碑载道，好评如潮</p>
							</li>
							<li class="youshi4">
								<p><strong>模块成熟，开箱即用</strong></p>
								<p>70+模块经100+工会的使用验证，愈发成熟，开箱即用</p>
							</li>
							<li class="youshi5">
								<p><strong>数据更安全</strong></p>
								<p>系统部署在校内机房，全程安全管控，数据安全有保障</p>
							</li>
							<li class="youshi6">
								<p><strong>全面满足工会日常工作</strong></p>
								<p>会员、提案、活动、慰问、福利……每项工作都举重若轻</p>
							</li>
							<li class="youshi7">
								<p><strong>快速演进</strong></p>
								<p>小步快跑，勇于试错，快速演进</p>
							</li>
							<li class="youshi8">
								<p><strong>全栈信创</strong></p>
								<p>适配国产主流的基础软硬件，如国产数据库、国产服务器操作系统</p>
							</li>
							<li class="youshi9">
								<p><strong>服务热情似火</strong></p>
								<p>好客山东，用山东人特有的憨厚朴实诚意相待</p>
							</li>
							<li class="youshi10">
								<p><strong>响应快速</strong></p>
								<p>将响应速度提升至分钟级别，展现特种兵的神速</p>
							</li>
						</ul>
					</div>
				</div>
				<div class="mobile_img">
					<ul class="shuxin_list" data-aos="flip-left">
						<li>
							<p><strong>创新不辍</strong></p>
							<p>60+软件著作权诠释数码人勇立潮头的不竭创新动力</p>
						</li>
						<li>
							<p><strong>专注、专业，更擅长</strong></p>
							<p>10+年专注智慧工会，具备丰富的智慧工会解决方案</p>
						</li>
						<li>
							<p><strong>服务有保障</strong></p>
							<p>100+高校工会的选择，口碑载道，好评如潮</p>
						</li>
						<li>
							<p><strong>模块成熟，开箱即用</strong></p>
							<p>70+模块经100+工会的使用验证，愈发成熟，开箱即用</p>
						</li>
						<li>
							<p><strong>数据更安全</strong></p>
							<p>系统部署在校内机房，全程安全管控，数据安全有保障</p>
						</li>
						<li>
							<p><strong>全面满足工会日常工作</strong></p>
							<p>会员、提案、活动、慰问、福利……每项工作都举重若轻</p>
						</li>
						<li>
							<p><strong>快速演进</strong></p>
							<p>小步快跑，勇于试错，快速演进</p>
						</li>
						<li>
							<p><strong>全栈信创</strong></p>
							<p>适配国产主流的基础软硬件，如国产数据库、国产服务器操作系统</p>
						</li>
						<li>
							<p><strong>服务热情似火</strong></p>
							<p>好客山东，用山东人特有的憨厚朴实诚意相待</p>
						</li>
						<li>
							<p><strong>响应快速</strong></p>
							<p>将响应速度提升至分钟级别，展现特种兵的神速</p>
						</li>
					</ul>
				</div>
			</div>
			<!--关于我们-->
			<!--天下工会一家亲-->
			<div class="main5_bg" data-aos="fade-down">
				<div class="main1">
					<div class="title1">
						<p><strong>天下工会一家亲</strong></p>
						<p>100+高校工会、医院工会选择数码人·智慧工会，感恩一路同行</p>
						<p><a href="javascript:void(0)" @click="goMore('/clientList')">查看更多智慧工会客户名录>></a></p>
					</div>
					<div class="main_c">
						<ul class="kehu_list">
							<!-- <li data-aos="flip-left" v-for="(item, index) in clientList" :key="index"><img
									:src="item.fileList&&item.fileList.length>0 && item.fileList[0].url" /></li> -->
									
									<li  v-for="(item, index) in clientList" :key="index"><img
											:src="item.image" /></li>
									
									

						</ul>
						<div class="title1">
							<p>排名不分先后</p>
						</div>
					</div>
				</div>
			</div>
			<!--天下工会一家亲-->

			<!--新闻资讯-->
			<div class="main1">
				<div class="title1"> <strong>数码人资讯</strong>
					<p><a href="javascript:void(0)" @click="goMore('/newList')">查看更多资讯>></a></p>
				</div>
				<div class="main_c">
					<div class="news_index">
						<div class="news_index_l" data-aos="fade-right">
							<ul class="news_index_l_list">
								<li v-for="(item, index) in xinwenList" :key="index"><a href="javascript:void(0)"
										@click="goMore('/context?id='+item.id)"><img :src="item.image" />
										<div class="index_news_t">{{ item.title }}</div>
										<div class="index_news_date">{{ item.createTime }}</div>
									</a></li>

							</ul>
						</div>
						<div class="news_index_r" data-aos="fade-left">
							<div class=" news_index_title"><span><a href="javascript:void(0)"
										@click="goMore('/newList')">更多</a></span>智慧工会新闻</div>
							<ul class="news_index_list">
								<li v-for="(item, index) in xinwenList2" :key="index"><a href="javascript:void(0)"
										@click="goMore('/context?id='+item.id)"><span>{{ item.createTime }}</span>{{ item.title }}</a></li>

							</ul>
						</div>
					</div>
				</div>
			</div>
			<!--新闻资讯-->
			<!--天下工会一家亲-->
			<div class="main7_bg">
				<div class="main1"  data-aos="fade-down">
					<div class="title1">
						<p><strong>资质、荣誉、知识产权</strong></p>
						<p><a href="javascript:void(0)" @click="goMore('/honorList')">查看更多资质荣誉>></a> <a
								href="javascript:void(0)" @click="goMore('/ipList')">查看更多知识产权>></a></p>
					</div>
					<div class="main_c">
						<ul class="rongyu_list">
							<li v-for="(item, index) in honorList" :key="index"><el-image :src="item.image"
									:preview-src-list="[item.image]">
								</el-image></li>

						</ul>
					</div>
				</div>
			</div>
			<!--天下工会一家亲-->

			<Footer></Footer>
		</div>


		<!--main-->
		<a href="javascript:scroll(0,0)" class="fanhui"></a>


	</div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'

	import $ from 'jquery';
	import '../../html/js/jquery.SuperSlide.2.1.3.js'
	import {
		getScrollList,
		getKeywordList,
		getClientList,
		getNewList,
		getCaseList,
		getHonorList,
		getSolutionList
	} from '@/api/reqFetch.js'
	export default {

		name: '',
		layout: '',
		components: {
			Footer,
			Header
		},
		data() {
			return {
				screenheight: '',
				aboutList: [{
					img: '',
					title: ''
				}],
				keyword: '',
				list: [],
				newList: [],
				newList1: [],
				jicenglist: [],
				tabList: [],
				selName: '全部',
				selid: '0',
				talentList: [],
				companyList: [],
				tableData: [],
				indexData: 0,
				pageNum: 4,
				bannerList: [],
				infoList1: [],
				infoList2: [],
				infoList3: [],
				index: 0,
				companyData: {},
				showPhone: false,
				adData: {},
				adData2: {},
				xinwenList: [],
				xinwenList2: [],
				honorList: [],
				clientList: [],
				caseList: [],
				jiejuefanganList: [],
				keyList: []
			}
		},



		mounted() {

			this.getBannerList()
			this.getCaseList()
			this.getNewList()
			this.getClientList()
			this.getHonorList()
			this.getSolutionList()
			this.getKeywordList()

		},

		methods: {
			getKeywordList() {
				getKeywordList().then(res => {
					this.keyList = res.data;
				});
			},
			goHref(item) {
				if (item.url) {
					window.open(item.url, item.target)
				}

			},

			getCaseList() {
				getCaseList({
					pageNumber: 1,
					pageSize: 6,
					categoryCode: '',
					categoryName: ''
				}).then(res => {
					this.caseList = res.data.list
				});
			},
			//解决方案列表
			getSolutionList() {
				getSolutionList({
					categoryCode: '2000',
				}).then(res => {
					const childList = res.data;
					const groupedChildList = childList.reduce((acc, item, index) => {
						const groupIndex = Math.floor(index / 6);
						if (!acc[groupIndex]) {
							acc[groupIndex] = [];
						}
						acc[groupIndex].push(item);
						return acc;
					}, []);
					// 若需保留原数据结构，可将分组后的数据赋值给新变量
					this.jiejuefanganList = groupedChildList;
					setTimeout(() => {
						$('#slideBox2').slide({
							mainCell: ".bd ul",
							autoPlay: false,
							interTime: "3500"
						});
					}, 50)
				});
			},

			changePhone(val) {
				this.showPhone = val
			},
			goProDetail(id) {
				this.$router.push({
					path: '/productDetail',
					query: {
						id: id
					}
				})
			},
			goMore(url) {
				this.$router.push(url)
			},
			goDetail(id) {
				this.$router.push({
					path: '/context',
					query: {
						id: id
					}
				})
			},


			getBannerList() {
				getScrollList({}).then(res => {
					this.bannerList = res.data
					setTimeout(() => {
						$('#slideBox').slide({
							mainCell: ".bd ul",
							autoPlay: true,
							interTime: "3500"
						});
					}, 50)

				});
			},
			getNewList() {

				//工会新闻-2200
				getNewList({
					categoryCode: '2201',
					pageNumber: 1,
					pageSize: 2,
				}).then(res => {
					if (res.data.list.length > 0) {
						this.xinwenList = res.data.list

					}
				});
				getNewList({
					categoryCode: '2202',
					pageNumber: 1,
					pageSize: 7,
				}).then(res => {
					if (res.data.list.length > 0) {
						this.xinwenList2 = res.data.list

					}
				});


			},
			getClientList() {
				getClientList({
					region: '',
					pageNumber: 1,
					pageSize: 24,
					client: ''
				}).then(res => {
					this.clientList = res.data.list

				});
			},
			getHonorList() {
				getHonorList({
					pageNumber: 1,
					pageSize: 4,
					direction:2
				}).then(res => {
					res.data.list.forEach(item => {
						// 处理fileList：过滤空url并生成srcList
						const validFiles = (item.fileList || []).filter(file => file.url);
						item.srcList = validFiles.map(file => file.url);
						// 取第一张有效图作为url（若存在）
						item.url = (validFiles || []).length > 0 ? validFiles[0].url : '';
					});
					this.honorList = res.data.list
				});
			},
			getCompanylist() {
				articleDetail({
					id: '1665924858784739328'
				}).then(res => {
					this.companyData = res.data;
				});
				articleDetail({
					id: '1665928502340853760'
				}).then(res => {
					this.adData = res.data;
				});
				articleDetail({
					id: '1665928576219324416'
				}).then(res => {
					this.adData2 = res.data;
				});

			},
			pros_hover(id) {
				this.selId = id
			},
			goMore(url) {
				this.$router.push(url)
			},
			goDetail(id) {
				this.$router.push({
					path: '/context',
					query: {
						id: id
					}
				})
			},
			goqyDetail(id) {
				this.$router.push({
					path: '/context',
					query: {
						id: id
					}
				})
			}
		}
	}
</script>

<style scoped>
	.el-carousel {
		width: 100%
	}
</style>